import { AmlFlowEnum } from '@/api';

const legacyToNewFlowMap: Partial<Record<AmlFlowEnum, AmlFlowEnum>> = {
  [AmlFlowEnum.LIGHT]: AmlFlowEnum.LITE,
};

const flowDisplayMap: Record<AmlFlowEnum, string> = {
  [AmlFlowEnum.ADVANCED_LIMITED]: `${AmlFlowEnum.ADVANCED}(PRO)`,
  [AmlFlowEnum.FAST_LIMITED]: `${AmlFlowEnum.FAST}(PRO)`,
  [AmlFlowEnum.ACCURATE]: AmlFlowEnum.ACCURATE,
  [AmlFlowEnum.ADVANCED]: `${AmlFlowEnum.ADVANCED}(Business)`,
  [AmlFlowEnum.FAST]: `${AmlFlowEnum.FAST}(Business)`,
  [AmlFlowEnum.LIGHT]: `${AmlFlowEnum.LITE}(Personal)`,
  [AmlFlowEnum.LITE]: `${AmlFlowEnum.LITE}(Personal)`,
  [AmlFlowEnum.INSTANT]: `${AmlFlowEnum.INSTANT}(Business)`,
};

export { flowDisplayMap, legacyToNewFlowMap };
